import type { AcceptedFormats } from "../../../../../components/UploadCard";
import type { EnergyAnalysisFileSection } from "../../model/types";

export const ENERGY_ANALYSIS_SECTIONS: { acceptedFormats: AcceptedFormats; section: EnergyAnalysisFileSection }[] = [
  {
    acceptedFormats: ["application/pdf", "image/*"],
    section: "energyCertificate",
  },
  {
    acceptedFormats: undefined,
    section: "bills",
  },
  {
    acceptedFormats: undefined,
    section: "buildingPlans",
  },
  {
    acceptedFormats: undefined,
    section: "technicalData",
  },
  {
    acceptedFormats: undefined,
    section: "otherDocuments",
  },
];
